// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"ReturnOrder_itemWrapper__AVKe3","item":"ReturnOrder_item__BHthg","removeBlock":"ReturnOrder_removeBlock__C4V8G"};